import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonPt from './locales/pt-BR/common.json';
import navPt from './locales/pt-BR/nav.json';
import authPt from './locales/pt-BR/auth.json';
import assistantPt from './locales/pt-BR/assistant.json';
import licensesPt from './locales/pt-BR/licenses.json';
import legislationPt from './locales/pt-BR/legislation.json';
import dashboardPt from './locales/pt-BR/dashboard.json';
import complaintsPt from './locales/pt-BR/complaints.json';
import identityPt from './locales/pt-BR/identity.json';
import catalogPt from './locales/pt-BR/catalog.json';
import institutionPt from './locales/pt-BR/institution.json';
import processPt from './locales/pt-BR/process.json';
import notificationsPt from './locales/pt-BR/notifications.json';
import settingsPt from './locales/pt-BR/settings.json';
import reportsPt from './locales/pt-BR/reports.json';
import mapPt from './locales/pt-BR/map.json';
import usersPt from './locales/pt-BR/users.json';
import profilePt from './locales/pt-BR/profile.json';
import adminPt from './locales/pt-BR/admin.json';
import enterprisesPt from './locales/pt-BR/enterprises.json';
import professionalPt from './locales/pt-BR/professional.json';
import billingPt from './locales/pt-BR/billing.json';
import contactPt from './locales/pt-BR/contact.json';

import commonEn from './locales/en/common.json';
import navEn from './locales/en/nav.json';
import authEn from './locales/en/auth.json';
import assistantEn from './locales/en/assistant.json';
import licensesEn from './locales/en/licenses.json';
import legislationEn from './locales/en/legislation.json';
import dashboardEn from './locales/en/dashboard.json';
import complaintsEn from './locales/en/complaints.json';
import identityEn from './locales/en/identity.json';
import catalogEn from './locales/en/catalog.json';
import institutionEn from './locales/en/institution.json';
import processEn from './locales/en/process.json';
import notificationsEn from './locales/en/notifications.json';
import settingsEn from './locales/en/settings.json';
import reportsEn from './locales/en/reports.json';
import mapEn from './locales/en/map.json';
import usersEn from './locales/en/users.json';
import profileEn from './locales/en/profile.json';
import adminEn from './locales/en/admin.json';
import enterprisesEn from './locales/en/enterprises.json';
import professionalEn from './locales/en/professional.json';
import billingEn from './locales/en/billing.json';
import contactEn from './locales/en/contact.json';

export const I18N_NAMESPACES = [
  'common',
  'nav',
  'auth',
  'assistant',
  'licenses',
  'legislation',
  'dashboard',
  'complaints',
  'identity',
  'catalog',
  'institution',
  'process',
  'notifications',
  'settings',
  'reports',
  'map',
  'users',
  'profile',
  'admin',
  'enterprises',
  'professional',
  'billing',
  'contact',
];

export const SUPPORTED_LOCALES = ['pt-BR', 'en'];
export const DEFAULT_LOCALE = 'pt-BR';
export const LOCALE_STORAGE_KEY = 'ambiental_locale';

export function normalizeLocale(lng) {
  if (!lng) return DEFAULT_LOCALE;
  const lower = String(lng).toLowerCase();
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('pt')) return 'pt-BR';
  return DEFAULT_LOCALE;
}

const resources = {
  'pt-BR': {
    common: commonPt,
    nav: navPt,
    auth: authPt,
    assistant: assistantPt,
    licenses: licensesPt,
    legislation: legislationPt,
    dashboard: dashboardPt,
    complaints: complaintsPt,
    identity: identityPt,
    catalog: catalogPt,
    institution: institutionPt,
    process: processPt,
    notifications: notificationsPt,
    settings: settingsPt,
    reports: reportsPt,
    map: mapPt,
    users: usersPt,
    profile: profilePt,
    admin: adminPt,
    enterprises: enterprisesPt,
    professional: professionalPt,
    billing: billingPt,
    contact: contactPt,
  },
  en: {
    common: commonEn,
    nav: navEn,
    auth: authEn,
    assistant: assistantEn,
    licenses: licensesEn,
    legislation: legislationEn,
    dashboard: dashboardEn,
    complaints: complaintsEn,
    identity: identityEn,
    catalog: catalogEn,
    institution: institutionEn,
    process: processEn,
    notifications: notificationsEn,
    settings: settingsEn,
    reports: reportsEn,
    map: mapEn,
    users: usersEn,
    profile: profileEn,
    admin: adminEn,
    enterprises: enterprisesEn,
    professional: professionalEn,
    billing: billingEn,
    contact: contactEn,
  },
};

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: DEFAULT_LOCALE,
      supportedLngs: SUPPORTED_LOCALES,
      ns: I18N_NAMESPACES,
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: LOCALE_STORAGE_KEY,
        convertDetectedLanguage: normalizeLocale,
      },
    });
}

export function changeAmbientLanguage(lng) {
  return i18n.changeLanguage(normalizeLocale(lng));
}

export default i18n;
